<ng-template #createNewTemplate let-item>
	<div class="flex justify-between">
		<span class="mr-3 whitespace-nowrap">{{ lawFirmName }}</span>
		<app-button
			(click)="createLawFirm()"
			[icon]="ICON.ADD"
			size="small"
			[cssClasses]="['button', 'text-xs']"
			[testHook]="testHooks.CreateLawFirmButton"
			>Create law firm</app-button
		>
	</div>
</ng-template>

<ng-template #lawFirmTemplate let-item>
	<div class="flex items-center" [testHook]="testHooks.LawFirmItemDiv">
		<app-icon class="m-2" [icon]="ICON.CORPORATION"></app-icon>
		<span class="font-bold whitespace-nowrap">{{ item.name | titlecase }}</span>
		<span class="pl-3 whitespace-nowrap">{{ item?.address?.street }}</span>
		<span class="pl-2 whitespace-nowrap">{{ item.firm }}</span>
	</div>
</ng-template>

<ng-template #lawyerTemplate let-item>
	<div class="flex items-center" [testHook]="testHooks.LawyerItemDiv">
		<atomic-name-badge
			[firstName]="item.firstName"
			[lastName]="item.lastName"
			size="small"
			[testHook]="testHooks.LawyerNameBadge"
		></atomic-name-badge>
		<span class="font-bold whitespace-nowrap ml-2"
			>{{ item.firstName | titlecase }} {{ item.lastName | titlecase }}</span
		>
		<span class="pl-2 whitespace-nowrap">{{ item.firm }}</span>
	</div>
</ng-template>

<ng-template #clerkTemplate let-item>
	<div class="flex items-center" [testHook]="testHooks.ClerkItemDiv">
		<atomic-name-badge
			[firstName]="item.firstName"
			[lastName]="item.lastName"
			size="small"
			[testHook]="testHooks.ClerkNameBadge"
		></atomic-name-badge>
		<span class="font-bold whitespace-nowrap ml-2"
			>{{ item.firstName | titlecase }} {{ item.lastName | titlecase }}</span
		>
		<span class="pl-2 whitespace-nowrap">{{ item.firm }}</span>
	</div>
</ng-template>

<div>
	<app-auto-complete
		(onSelect)="onSelect($event)"
		[skeletonLoading]="skeletonLoading"
		[placeholder]="placeholder"
		[itemGroups]="[
			{ items: [{ value: 'createNew' }], template: createNewTemplate },
			{
				items: (lawFirms$ | async),
				template: lawFirmTemplate,
				title: 'Existing Law firms',
				noResultsMessage: 'No firms found',
				type: dropdownSelect.SELECTLAWFIRM,
			},
			{
				items: lawyers,
				template: lawyerTemplate,
				title: 'Existing Lawyers',
				type: dropdownSelect.SELECTLAWYER,
			},
			{
				items: clerks,
				template: clerkTemplate,
				title: 'Existing Clerks',
				type: dropdownSelect.SELECTCLERK,
			},
		]"
		[(ngModel)]="lawFirmName"
		name="dual-dropdown-1"
		(debounce)="search($event)"
		[loading]="loading"
		[skeletonLoading]="skeletonLoading"
		width="w-full"
		[label]="label"
		[testHook]="testHooks.SearchAutoComplete"
		[labelIcon]="AI_ICON"
		[labelIconClasses]="AI_CLASSES"
		[labelToolTip]="showAiIcon ? AI_TOOLTIP : ''"
	>
	</app-auto-complete>
</div>
